import React from 'react';
import EditorCandidateInfoModal from './editorCandidateInfoModal';

class EditCandidateInfoModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div className="lit-modal" onClick={() => this.props.onCancel()}>
				<div
					className="lit-modal__other"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div>
						<EditorCandidateInfoModal
							onEditModelConfirm={this.props.onConfirm}
							onEditModelCancel={this.props.onCancel}
							selectedTestUser={this.props.selectedTestUser}
							getTestsBySearch={this.props.getTestsBySearch}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default EditCandidateInfoModal;
